import { Table, Stack, TableBody, TableCell, TableContainer, Avatar, TableHead, Tabs, Tab, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar, createFilterOptions, Select, MenuItem, Dialog, DialogTitle, DialogContent, Checkbox, Chip, IconButton, Rating, Card, CardContent, Paper, CardHeader } from "@mui/material";
import { useState, useEffect, useRef, useMemo } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useVendorEnquiryIDByDepartmentID from "../../../hooks/useVendorEnquiryIDByDepartmentID";
import useLoadVendorQuotationDetailByVendor from "../../../hooks/useLoadVendorQuotationDetailByVendor";
import useVendorQuotationCRUD from "../../../hooks/useVendorQuotationCRUD";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";

import CompareQuotations from "./CompareQuotations";
import useGetVendorEnquiryDetByPurchaseID from "../../../hooks/useGetVendorEnquiryDetByPurchaseID";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import useVendorEnquieyList from "../../../hooks/useVendorEnquieyList";

import VendorResponseActionMenu from "../vendor-quotation/VendorResponseSubMenu";
import useVendorQuotationList from "../../../hooks/useVendorQuotationList";
import AddNewPurchaseOrder from "../order/AddPurchaseOrder";
import axios from "axios";
import useEnquiryResponseDetailsByPurchaseId from "../../../hooks/purchase/useEnquiryResponseDetailsByPurchaseId";
import { PURCHASE_API_ENDPOINTS } from "../../../config/api/apiCallPurchase";
import { EnquiryResponseComparisonApprove, EnquiryResponseComparisonSave } from "../../../services/vendorEnquiryService";
import useVendorEnquiryComparisonList from "../../../hooks/purchase/useVendorEnquiryComparisionList";
import useEnquiryResponseComparisionDetByID from "../../../hooks/purchase/useEnquiryResponseComparisionDetByID";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import { Approval, ApprovalOutlined, AutoFixHigh, Check, Create, CreateOutlined, Palette } from "@mui/icons-material";
import { el } from "date-fns/locale";
import { set } from "date-fns";
import EnquiryComparisionSubMenu from "./EnquiryComparisionSubMenu";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { t } from "i18next";
import { dark } from "@mui/material/styles/createPalette";


const filter = createFilterOptions();

export const fetchVendorResponses = async (enquiryId) => {
    // Mock API response for now
    return [
        {
            id_material: 101,
            material_name: "Pulp Roll A",
            vendor_name: "Vendor A",
            id_party: 201,
            quoted_price: 120,
            required_quantity: 1000,
            delivery_date: "2025-11-20",
        },
        {
            id_material: 101,
            material_name: "Pulp Roll A",
            vendor_name: "Vendor B",
            id_party: 202,
            quoted_price: 130,
            required_quantity: 1000,
            delivery_date: "2025-11-22",
        },
        {
            id_material: 102,
            material_name: "Paper Sheet B",
            vendor_name: "Vendor A",
            id_party: 201,
            quoted_price: 210,
            required_quantity: 500,
            delivery_date: "2025-11-21",
        },
    ];
};

export const saveVendorComparison = async (payload) => {
    console.log("Saving comparison:", payload);
    return { success: true };
};

// VendorComparisonPage.js

// replace existing calculateScore with this
const calculateScore = (quoted_price, delivery_date, payment_terms) => {
    // ensure numeric values
    const price = Number(quoted_price) || 0;
    const terms = Number(payment_terms) || 0;

    // parse delivery_date safely using dayjs (works for 'DD-MMM-YYYY' or ISO)
    const today = dayjs().startOf('day');
    const dl = delivery_date ? dayjs(delivery_date) : null;

    let deliveryDays = null;
    if (dl && dl.isValid()) {
        deliveryDays = dl.startOf('day').diff(today, 'day'); // days from today
    }

    // priceScore: lower price → higher score. guard divide by zero
    const priceScore = price > 0 ? (1 / price) * 50 : 0;

    // deliveryScore: sooner delivery => higher score; positive days (future)
    const deliveryScore = (deliveryDays !== null && deliveryDays > 0) ? (1 / deliveryDays) * 30 : 0;

    // paymentScore: shorter payment terms (days) => lower score? original formula (payment_terms / 30) * 20
    // keep original but guard
    const paymentScore = terms > 0 ? (terms / 30) * 20 : 0;

    const total = priceScore + deliveryScore + paymentScore;
    // return number (not string) to make arithmetic easier later
    return Number(total.toFixed(2));
};

const calculateVendorScoresByMaterial = (rows) => {
    const today = dayjs().startOf("day");
    const result = [];

    const grouped = rows.reduce((acc, r) => {
        acc[r.material_code] = acc[r.material_code] || [];
        acc[r.material_code].push(r);
        return acc;
    }, {});

    Object.values(grouped).forEach(group => {
        const prices = group.map(r => Number(r.quoted_price) || 0);
        const terms = group.map(r => Number(r.payment_terms) || 0);

        const deliveryDays = group.map(r => {
            const d = dayjs(r.delivery_date);
            return d.isValid() ? Math.max(d.diff(today, "day"), 0) : 9999;
        });

        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);

        const minTerms = Math.min(...terms);
        const maxTerms = Math.max(...terms);

        const minDelivery = Math.min(...deliveryDays);
        const maxDelivery = Math.max(...deliveryDays);

        group.forEach(r => {
            const price = Number(r.quoted_price) || 0;
            const termsVal = Number(r.payment_terms) || 0;

            const d = dayjs(r.delivery_date);
            const dDays = d.isValid() ? Math.max(d.diff(today, "day"), 0) : 9999;

            const priceScore =
                maxPrice === minPrice
                    ? 100
                    : ((maxPrice - price) / (maxPrice - minPrice)) * 100;

            const paymentScore =
                maxTerms === minTerms
                    ? 100
                    : ((termsVal - minTerms) / (maxTerms - minTerms)) * 100;

            const deliveryScore =
                maxDelivery === minDelivery
                    ? 100
                    : ((maxDelivery - dDays) / (maxDelivery - minDelivery)) * 100;

            const totalScore =
                priceScore * 0.5 +
                paymentScore * 0.3 +
                deliveryScore * 0.2;

            result.push({
                ...r,
                totalScore: Number(totalScore.toFixed(2))
            });
        });
    });

    // Rank per material
    return result.map(r => {
        const sameMaterial = result
            .filter(x => x.material_code === r.material_code)
            .sort((a, b) => b.totalScore - a.totalScore);

        const rank =
            sameMaterial.findIndex(x => x.id_party === r.id_party) + 1;

        return {
            ...r,
            rank,
            isTopVendor: rank === 1
        };
    });
};


// const calculateVendorScoresByMaterial = (rows) => {
//   const today = dayjs().startOf("day");
//   const result = [];

//   const grouped = rows.reduce((acc, r) => {
//     acc[r.material_code] = acc[r.material_code] || [];
//     acc[r.material_code].push(r);
//     return acc;
//   }, {});

//   Object.values(grouped).forEach(group => {
//     const prices = group.map(r => Number(r.quoted_price) || 0);
//     const terms = group.map(r => Number(r.payment_terms) || 0);
//     const deliveryDays = group.map(r =>
//       dayjs(r.delivery_date).diff(today, "day")
//     );

//     const minPrice = Math.min(...prices);
//     const maxPrice = Math.max(...prices);

//     const minTerms = Math.min(...terms);
//     const maxTerms = Math.max(...terms);

//     const minDelivery = Math.min(...deliveryDays);
//     const maxDelivery = Math.max(...deliveryDays);

//     group.forEach(r => {
//       const priceScore =
//         maxPrice === minPrice
//           ? 100
//           : ((maxPrice - r.quoted_price) / (maxPrice - minPrice)) * 100;

//       const paymentScore =
//         maxTerms === minTerms
//           ? 100
//           : ((maxTerms - r.payment_terms) / (maxTerms - minTerms)) * 100;

//       const dDays = dayjs(r.delivery_date).diff(today, "day");
//       const deliveryScore =
//         maxDelivery === minDelivery
//           ? 100
//           : ((maxDelivery - dDays) / (maxDelivery - minDelivery)) * 100;

//       const totalScore =
//         priceScore * 0.5 +
//         paymentScore * 0.3 +
//         deliveryScore * 0.2;

//       result.push({
//         ...r,
//         totalScore: Number(totalScore.toFixed(2))
//       });
//     });
//   });

//   // ranking per material
//   return result.map(r => {
//     const sameMaterial = result
//       .filter(x => x.material_code === r.material_code)
//       .sort((a, b) => b.totalScore - a.totalScore);

//     const rank =
//       sameMaterial.findIndex(x => x.id_party === r.id_party) + 1;

//     return {
//       ...r,
//       rank,
//       isTopVendor: rank === 1
//     };
//   });
// };


const getDelayDays = (vendorDate, requiredDate) => {
    if (!vendorDate || !requiredDate) return null;
    return dayjs(vendorDate).diff(dayjs(requiredDate), "day");
};

const formatDate = (date) =>
    date ? dayjs(date).format("DD-MMM-YYYY") : "-";

const AddCompareVendorQuotations = ({ handlecallback, quotationData: editPurchaseIndentID, para_selectedDepartment, para_selectedPurchaseIndentNo, selectedMode, selectedRows, comparisionStatus, showOnlyApprovedComparisions = false }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [openPreviewModal, setOpenPreviewModal] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const { vendorIDList, selectedVendoIdList, selectedVendoIdListID, setSelectedVendoIdList, setSelectedVendoIdListID, loadVenodrIDByDepartmentID, loadVenodrListByEnquiryIDLocal, vendorList, selectedVendoList, selectedVendoListID, setSelectedVendoList, setSelectedVendoListID } = useVendorEnquiryIDByDepartmentID(0);
    const [remarks, setRemarks] = useState('');

    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);

    const { requestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
    const { VendorQuotationDetails, loadVendorDetailByVendorID, } = useLoadVendorQuotationDetailByVendor();
    const { vendorEnquiryDet, setvendorEnquiryDet, loadVendorEnquiryDet } = useGetVendorEnquiryDetByPurchaseID();


    const {
        responseDetailsList,
        selectedResponse,
        loadEnquiryResponseWhenPurchaseSelected
    } = useEnquiryResponseDetailsByPurchaseId();



    const [partyList, setPartyList] = useState([]);
    const [filteredParties, setFilteredParties] = useState([]); // filtered ones from indent
    const [isPartyDisabled, setIsPartyDisabled] = useState(true); // control disable



    const [selectedParty, setSelectedParty] = useState(null);

    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };


    // const { processIndent } = useVendorQuotationCRUD(callMessage);
    const hasLoadedRequestDetails = useRef(false);
    const hasLoadedVendorDetails = useRef(false);

    const [openVendorQuotation, setOpenVendorQuotation] = useState(true);
    const [openVendorCompareQuotation, setOpenVendorCompareQuotation] = useState(false);

    const [tableRows, setTableRows] = useState([{ id_material: 0, material_code: '', material_description: '', quantity_required: 0, quoted_price: 0, party_name: '', delivery_date: '', payment_terms: 0, rating: '', id_party: 0, required_date: '' }]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    //  const [selectedVendors, setSelectedVendors] = useState({});
    const [poPreviewOpen, setPoPreviewOpen] = useState(false);
    const [vendorGroupedPOs, setVendorGroupedPOs] = useState({});

    const [vendorCompare, setVendorCompare] = useState(true);
    const [purchase_order, setPurchase_order] = useState(false);

    const [selectedVendorForPO, setSelectedVendorForPO] = useState([]);
    const [purchase_indent_no, setpurchase_indent_no] = useState('');
    const [globalSelectedVendor, setGlobalSelectedVendor] = useState(null);

    const [visibleGeneratePOButton, setVisibleGeneratePOButton] = useState(false);
    const [visibleApproveButton, setVisibleApproveButton] = useState(false);
    const [visibleSaveBtn, setVisibleSaveBtn] = useState(true);

    const getRequestDetailByRequestID = async (id_request) => {

        await loadVenodrIDByDepartmentID(selectedDepartmentID, null, id_request);

    }

    const { comparisonHeader, comparisonDetails, hdrId, loadVendorComparisonByHdrId } = useEnquiryResponseComparisionDetByID();




    // Fetch details when HDR ID changes
    useEffect(() => {
        const fetchData = async () => {
            if (editPurchaseIndentID && department.length > 0) {
                const data = await loadVendorComparisonByHdrId(Number(editPurchaseIndentID));

                setRemarks(data.header.remarks || '');

                const deptId = data.header.id_department || 0;
                setSelectedDepartmentID(deptId);

                const selectedDept = department.find(d => d.id === deptId);
                setSelectedDepartment(selectedDept || null);

                await handleDepartmentChange(null, selectedDept || null);
                setSelectedRequestIndentNumberListID(data.header.id_purchase || 0);

                // const isApproved = comparisionStatus === "Approved";

                // setVisibleGeneratePOButton(isApproved);
                // setVisibleApproveButton(!isApproved);
                // setVisibleSaveBtn(!isApproved);



                setVisibleGeneratePOButton(false);
                setVisibleApproveButton(false);
                setVisibleSaveBtn(false);

                if (comparisionStatus === "pending") {
                    setVisibleSaveBtn(true);
                    setVisibleApproveButton(true);
                }

                if (comparisionStatus === "Approved" || comparisionStatus === "Converted") {
                    if (showOnlyApprovedComparisions) {
                        setVisibleGeneratePOButton(true);
                    }
                }


            }
        };

        fetchData();
    }, [editPurchaseIndentID, department]);

    useEffect(() => {
        if (requestIndentNumberList.length > 0 && selectedRequestIndentNumberListID) {

            const selectedIndent = requestIndentNumberList.find(
                (item) => item.id_request === selectedRequestIndentNumberListID
            );

            setSelectedRequestIndentNumberList(selectedIndent || null);
            handlePurchaseIndentChange(null, selectedIndent || null);
        }
    }, [requestIndentNumberList, selectedRequestIndentNumberListID]);



    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPartyList(data);
                        setFilteredParties([]); // initially empty
                        setIsPartyDisabled(true); // initially disabled
                    }
                })
                .catch(error => {
                    alert('error', error.message, 'Error');
                });
        }



    }, [isDataLoaded]);

    useEffect(() => {
        if (VendorQuotationDetails && VendorQuotationDetails.length > 0) {
            //setTableRows(VendorQuotationDetails);
            const formattedData = VendorQuotationDetails.map((item) => {
                const rawDate = item.delivery_date;

                const isInvalidDate =
                    !rawDate || rawDate === '0001-01-01T00:00:00' || rawDate === '0001-01-01';

                return {
                    ...item,
                    delivery_date: isInvalidDate
                        ? null
                        : dayjs(rawDate).format('DD-MMM-YYYY')
                };
            });
            setTableRows(formattedData);
        }
    }, [VendorQuotationDetails]);

    useEffect(() => {
        if (para_selectedDepartment) {
            setSelectedDepartment(para_selectedDepartment);
            loadVenodrIDByDepartmentID(para_selectedDepartment.id, 'vendor enquiry');
        }
    }, [loadVenodrIDByDepartmentID, para_selectedDepartment, setSelectedDepartment]);


    useEffect(() => {
        if (!hasLoadedRequestDetails.current && para_selectedPurchaseIndentNo && para_selectedPurchaseIndentNo.id_request) {
            setSelectedRequestIndentNumberList(para_selectedPurchaseIndentNo);
            setSelectedRequestIndentNumberListID(para_selectedPurchaseIndentNo.id_request);
            getRequestDetailByRequestID(para_selectedPurchaseIndentNo.id_request);

            hasLoadedRequestDetails.current = true; // prevent future runs
        }
    }, [para_selectedPurchaseIndentNo]);


    useEffect(() => {
        if (editPurchaseIndentID) {
            setSelectedVendoIdListID(editPurchaseIndentID);
            loadVendorDetailByVendorID(editPurchaseIndentID, editPurchaseIndentID);

            const selectedVendor = vendorIDList.find(vendor => vendor.id_enquiry === editPurchaseIndentID);
            if (selectedVendor) {
                setSelectedVendoIdList(selectedVendor);
                setSelectedVendoIdListID(selectedVendor.id_enquiry);
            }




            hasLoadedVendorDetails.current = true; // prevent future runs
        }
    }, [editPurchaseIndentID, vendorIDList, partyList]);


    useEffect(() => {
        const defaultRow = {
            id_material: 0,
            material_code: '',
            material_description: '',
            quantity_required: 0,
            quoted_price: 0,
            party_name: '',
            delivery_date: '',
            payment_terms: 0,
            rating: '',
            id_party: 0
        };

        let incomingData = selectedRows?.details;

        // 🔥 Parse it if it's a JSON string
        if (typeof incomingData === 'string') {
            try {
                incomingData = JSON.parse(incomingData);
            } catch (e) {
                console.error('Failed to parse selectedRows.details:', e);
                incomingData = [];
            }
        }

        const normalizedRows = Array.isArray(incomingData)
            ? incomingData
            : incomingData
                ? [incomingData]
                : [];

        const formattedRows = normalizedRows.map((item) => ({
            id_material: item.id_material || 0,
            material_code: item.material_code || '',
            material_description: item.material_description || '',
            quantity_required: item.quantity_required || 0,
            quoted_price: item.quoted_price || 0,
            party_name: item.party_name || '',
            delivery_date: item.delivery_date
                ? dayjs(item.delivery_date).format('DD-MMM-YYYY')
                : '',
            payment_terms: item.payment_terms || 0,
            rating: item.rating || '',
            id_party: item.id_party || 0
        }));

        setTableRows(formattedRows.length > 0 ? formattedRows : [defaultRow]);
    }, [selectedRows]);




    const calculateRatings = (rows) => {
        const updatedRows = [...rows];
        const materialGroups = {};

        // Group rows by material code
        updatedRows.forEach(row => {
            const code = row.material_code;
            if (!materialGroups[code]) {
                materialGroups[code] = [];
            }
            materialGroups[code].push(row);
        });

        // Assign L1, L2, etc. based on lowest quoted_price per material
        Object.values(materialGroups).forEach(group => {
            // Sort by quoted price ascending
            group.sort((a, b) => a.quoted_price - b.quoted_price);

            // Assign ratings (L1, L2, ...)
            group.forEach((row, index) => {
                row.rating = `L${index + 1}`;
            });
        });

        return updatedRows;
    };

    useEffect(() => {
        if (tableRows && tableRows[0]?.id_material !== 0) {
            const ratedRows = calculateRatings(tableRows);

            const isSame =
                JSON.stringify(ratedRows) === JSON.stringify(tableRows); // ⚠️ not best for large data, but simple fix

            if (!isSame) {
                setTableRows(ratedRows);
            }
        }
    }, [tableRows]);



    const callback = () => {
        handlecallback();
    }

    const handleSave = async () => {
        try {

            // 💥 Build save rows from FILTERED ROWS (not selectedVendors)
            // const rowsToSave = filteredRows.map(r => {
            //     const selected = selectedVendors[r.material_code]
            //         ?.find(v => v.id_party === r.id_party);

            //     const selectedQty = selected?.selectedQty ?? 0;

            //     const score =
            //         selected?.score ??
            //         calculateScore(r.quoted_price, r.delivery_date, r.payment_terms);

            //     return {
            //         material_code: r.material_code,
            //         material_name: r.material_description,
            //         id_material: r.id_material,
            //         quoted_price: Number(r.quoted_price),
            //         delivery_date: r.delivery_date,
            //         payment_term: r.payment_terms,
            //         required_quantity: Number(r.quantity_required) || 0,
            //         remaining_quantity: (Number(r.quantity_required) || 0) - Number(selectedQty),
            //         vendor_assign_quantity: Number(selectedQty),
            //         score,
            //         id_party: r.id_party,
            //         rank: r.rank ?? 1,
            //         is_selected: selectedQty > 0,
            //         id_response_hdr: r.id_response_hdr,
            //         id_response_det: r.id_response_det,
            //         id_enquiry_hdr: r.id_enquiry_hdr,
            //         id_purchase: selectedRequestIndentNumberListID
            //     };
            // });

            const rowsToSave = scoredRows.map(r => {
                const selected = selectedVendors[r.material_code]
                    ?.find(v => v.id_party === r.id_party);

                const selectedQty = selected?.selectedQty ?? 0;

                return {
                    material_code: r.material_code,
                    material_name: r.material_description,
                    id_material: r.id_material,
                    quoted_price: Number(r.quoted_price),
                    delivery_date: r.delivery_date,
                    payment_term: r.payment_terms,
                    required_quantity: Number(r.quantity_required) || 0,
                    vendor_offered_qty: Number(r.vendor_offered_qty) || 0,
                    remaining_quantity:
                        (Number(r.quantity_required) || 0) - Number(selectedQty),
                    vendor_assign_quantity: Number(selectedQty),

                    // ✅ USE PRE-CALCULATED SCORE
                    score: r.totalScore ?? 0,

                    id_party: r.id_party,
                    rank: r.rank ?? 1,
                    is_selected: selectedQty > 0,
                    id_response_hdr: r.id_response_hdr,
                    id_response_det: r.id_response_det,
                    id_enquiry_hdr: r.id_enquiry_hdr,
                    id_purchase: selectedRequestIndentNumberListID,
                    id_payment_terms: r.id_payment_terms,
                    id_discount: r.id_discount,
                    id_tcs: r.id_tcs,
                    id_tds: r.id_tds,
                    discount_value: r.discount_value,
                    tax_value: r.tax_value,
                    tcs_value: r.tcs_value,
                    tds_value: r.tds_value,
                    fright: r.fright,

                    cgst_rate: r.cgst_rate,
                    cgst_amount: r.cgst_amount,
                    sgst_rate: r.sgst_rate,
                    sgst_amount: r.sgst_amount,
                    igst_rate: r.igst_rate,
                    igst_amount: r.igst_amount
                };
            });


            if (rowsToSave.length === 0) {
                callMessage('warning', 'No data to save.', 'No Data');
                return;
            }

            const hdr = rowsToSave[0];

            const body = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
                p_id_department: selectedDepartmentID,
                p_id_purchase: hdr.id_purchase,
                p_id_enquiry_hdr: hdr.id_enquiry_hdr,
                p_comparison_date: new Date(),
                p_created_by: localStorage.getItem("userID"),
                p_remarks: remarks,
                p_det: rowsToSave,
                p_id_compare: editPurchaseIndentID ? Number(editPurchaseIndentID) : 0
            };

            const data = await EnquiryResponseComparisonSave(body);

            if (data?.length > 0) {
                if (editPurchaseIndentID) {
                    callMessage('info', 'Comparison details updated successfully', 'Info');
                }
                else {
                    callMessage('success', 'Comparison saved successfully', 'Success');
                }

            }

        } catch (err) {
            console.error("Save failed:", err);
            callMessage('error', 'Failed to save comparison', 'Error');
        }
    };

    const handleApprove = async () => {
        try {

            if (!editPurchaseIndentID) {
                callMessage("warning", "No record selected for approval.", "Warning");
                return;
            }

            const confirmApproval = window.confirm(
                "Are you sure you want to approve this comparison?"
            );

            if (!confirmApproval) {
                callMessage("info", "Approval cancelled", "Cancelled");
                return;
            }


            const body = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
                p_hdr_id: editPurchaseIndentID,     // 👈 main header ID for approval
                p_approved_by: localStorage.getItem("userID"),
                p_status: "Approved"                   // or “Rejected” later if needed
            };

            const data = await EnquiryResponseComparisonApprove(body);

            if (data?.length > 0) {
                callMessage(
                    "success",
                    "Comparison approved successfully",
                    "Success"
                );
                // setVisibleGeneratePOButton(true);
                setVisibleApproveButton(false);
                setVisibleSaveBtn(false);
            }
            else {
                callMessage(
                    "error",
                    "Not able to approve this comparison",
                    "Error"
                );
            }

        } catch (err) {
            console.error("Approval failed:", err);
            callMessage("error", "Failed to approve comparison", "Error");
        }
    };




    const handlecallProcess = (buttonName) => {
        if (buttonName === 'Email') {
            setOpenPreviewModal(true);
        }
        else if (buttonName === 'CompareQuotation') {
            setOpenVendorQuotation(true);
            setOpenVendorCompareQuotation(true);

            const filteredRows = tableRows.filter(row => row.quantity_required > 0);
            setFilteredRows(filteredRows);
        }

    };

    useEffect(() => {
        if (filteredRows.length === 0) return;

        // If already assigned qty exists → do NOT reset
        const hasExistingQty = filteredRows.some(r => r.selectedQty > 0);

        if (hasExistingQty) {
            // edit mode → do nothing
            return;
        }

        // new comparison mode → initialize blank vendor list
        const materialCodes = [...new Set(filteredRows.map(q => q.material_code))];
        setSelectedVendors(materialCodes.reduce((acc, code) => ({ ...acc, [code]: [] }), {}));
    }, [filteredRows]);




    useEffect(() => {
        if (vendorEnquiryDet && vendorEnquiryDet.length > 0 && partyList.length > 0) {
            const filtered = partyList.filter(p => vendorEnquiryDet[0].party_ids.includes(p.id));
            setFilteredParties(filtered);        // ✅ show only matching parties
            setIsPartyDisabled(false);           // ✅ enable Autocomplete
            setSelectedParty(null);              // optional: clear previous selection
            loadVendorDetailByVendorID(vendorEnquiryDet[0]?.id_enquiry_hdr, vendorEnquiryDet[0]?.id_enquiry_hdr);
        }
    }, [vendorEnquiryDet, partyList]);

    const [selectedVendors, setSelectedVendors] = useState({});




    const handlePurchaseIndentChange = async (event, newValue) => {
        if (newValue == null) {
            setSelectedRequestIndentNumberList(null);
            setSelectedRequestIndentNumberListID(null);
            return;
        }

        setSelectedRequestIndentNumberList(newValue);
        setSelectedRequestIndentNumberListID(newValue.id_request);

        await getRequestDetailByRequestID(newValue.id_request);
        await loadVendorEnquiryDet(newValue.id_request);

        let resp;

        // edit mode uses compareID
        if (editPurchaseIndentID) {
            resp = await loadEnquiryResponseWhenPurchaseSelected(
                newValue.id_request,
                editPurchaseIndentID
            );
        } else {
            resp = await loadEnquiryResponseWhenPurchaseSelected(
                newValue.id_request,
                0
            );
        }

        if (!resp || resp.length === 0) {
            setFilteredRows([]);
            return;
        }

        // PARSE DETAILS
        // const filteredDetails = resp.flatMap(item => {
        //     if (item.id_purchase !== newValue.id_request) return [];

        //     const detailsArray = JSON.parse(item.details);

        //     return detailsArray
        //         .filter(d => d.quantity_required > 0)
        //         .map(d => ({
        //             ...d,
        //             party_name: item.party_name,
        //             id_party: item.id_party,        // assign correct vendor
        //             selectedQty: d.vendor_assign_quantity ?? 0, // important,
        //             id_purchase_order: d.id_purchase_order ?? null,
        //             status: d.status ?? null,
        //         }));
        // });

        const filteredDetails = resp.flatMap(item => {
            // if (item.id_purchase !== newValue.id_request) return [];

            const detailsArray = JSON.parse(item.details ?? "[]");

            return detailsArray
                .filter(d => d.quantity_required > 0)
                .map(d => ({
                    ...d,
                    party_name: d.party_name,
                    id_party: d.id_party,
                    selectedQty: d.vendor_assign_quantity ?? 0,
                    id_purchase_order: d.id_purchase_order ?? null,
                    status: d.status ?? null,
                }));
        });


        // store in filteredRows
        setFilteredRows(filteredDetails);

        // ----------------------------------------------------------
        // 🔥 MAIN FIX: RESTORE selected vendors when editing
        // ----------------------------------------------------------
        if (editPurchaseIndentID) {
            const selectedMap = {};

            filteredDetails.forEach(r => {
                if (r.selectedQty > 0) {
                    if (!selectedMap[r.material_code]) {
                        selectedMap[r.material_code] = [];
                    }

                    selectedMap[r.material_code].push({
                        ...r,
                        selectedQty: r.selectedQty,
                        score: calculateScore(
                            r.quoted_price,
                            r.delivery_date,
                            r.payment_terms
                        ),
                        id_purchase_order: r.id_purchase_order,
                        status: r.status

                    });
                }
            });

            setSelectedVendors(selectedMap);
        }
        // ----------------------------------------------------------

        if (filteredDetails.length > 0) {
            setOpenVendorQuotation(true);
            setOpenVendorCompareQuotation(true);
        }
    };

    const scoredRows = useMemo(() => {
        if (!filteredRows.length) return [];
        return calculateVendorScoresByMaterial(filteredRows);
    }, [filteredRows]);




    const handleVendorCheck = (material_code, row, isChecked) => {
        setSelectedVendors(prev => {
            const updated = { ...prev };

            if (!updated[material_code]) updated[material_code] = [];

            // UNCHECK → remove vendor
            if (!isChecked) {
                updated[material_code] = updated[material_code].filter(
                    v => v.id_party !== row.id_party
                );
                if (updated[material_code].length === 0) delete updated[material_code];
                return updated;
            }

            // CHECK → auto assign remaining qty
            const requiredQty = row.quantity_required || 0;
            const vendorOfferQty = Number(row.vendor_offered_qty || 0);

            const alreadyAssigned = updated[material_code].reduce(
                (s, v) => s + (Number(v.selectedQty) || 0),
                0
            );

            //const remaining = requiredQty - alreadyAssigned;

            const remainingRequired = requiredQty - alreadyAssigned;

            const assignQty = Math.min(remainingRequired, vendorOfferQty);


            const score = calculateScore(row.quoted_price, row.delivery_date, row.payment_terms);

            updated[material_code].push({
                ...row,
                selectedQty: assignQty > 0 ? assignQty : 0,
                score
            });

            return updated;
        });
    };


    // const handleSelect = (material_code, row, quantity) => {
    //     setSelectedVendors(prev => {
    //         const updated = { ...prev };

    //         if (!updated[material_code]) updated[material_code] = [];

    //         const requiredQty = row.quantity_required || 0;

    //         // remove vendor when qty is 0
    //         if (!quantity || quantity === 0) {
    //             updated[material_code] = updated[material_code].filter(
    //                 v => v.id_party !== row.id_party
    //             );
    //             if (updated[material_code].length === 0) delete updated[material_code];
    //             return updated;
    //         }

    //         // recalc assigned qty except current vendor
    //         const alreadyAssigned = updated[material_code]
    //             .filter(v => v.id_party !== row.id_party)
    //             .reduce((s, v) => s + (Number(v.selectedQty) || 0), 0);

    //         if (alreadyAssigned + Number(quantity) > requiredQty) {
    //             alert(`Assigned qty cannot exceed ${requiredQty}`);
    //             return prev;
    //         }

    //         const score = calculateScore(row.quoted_price, row.delivery_date, row.payment_terms);

    //         const existingIndex = updated[material_code].findIndex(
    //             v => v.id_party === row.id_party
    //         );

    //         const newObj = {
    //             ...row,
    //             selectedQty: Number(quantity),
    //             score
    //         };

    //         if (existingIndex >= 0) updated[material_code][existingIndex] = newObj;
    //         else updated[material_code].push(newObj);

    //         return updated;
    //     });
    // };

    const handleSelect = (material_code, row, quantity) => {
        setSelectedVendors(prev => {
            const updated = { ...prev };

            if (!updated[material_code]) updated[material_code] = [];

            const requiredQty = Number(row.quantity_required || 0);
            const vendorOfferQty = Number(row.vendor_offered_qty || 0);
            const enteredQty = Number(quantity || 0);

            // remove vendor
            if (enteredQty === 0) {
                updated[material_code] = updated[material_code].filter(
                    v => v.id_party !== row.id_party
                );
                if (updated[material_code].length === 0) delete updated[material_code];
                return updated;
            }

            if (enteredQty > vendorOfferQty) {
                alert(`Vendor can supply only ${vendorOfferQty}`);
                return prev;
            }

            const alreadyAssigned = updated[material_code]
                .filter(v => v.id_party !== row.id_party)
                .reduce((s, v) => s + Number(v.selectedQty || 0), 0);

            if (alreadyAssigned + enteredQty > requiredQty) {
                alert(`Total assigned cannot exceed ${requiredQty}`);
                return prev;
            }

            const score = calculateScore(
                row.quoted_price,
                row.delivery_date,
                row.payment_terms
            );

            const existingIndex = updated[material_code].findIndex(
                v => v.id_party === row.id_party
            );

            const newObj = {
                ...row,
                selectedQty: enteredQty,
                score
            };

            if (existingIndex >= 0) updated[material_code][existingIndex] = newObj;
            else updated[material_code].push(newObj);

            return updated;
        });
    };


    useEffect(() => {
        if (selectedRequestIndentNumberList) {
            setpurchase_indent_no(selectedRequestIndentNumberList.request_indent_number);
        }
    }, [selectedRequestIndentNumberList]);


    const getRemainingQty = (material_code) => {

        // handle both fresh & saved comparison structure
        const row = filteredRows.find(q => q.material_code === material_code);

        if (!row) return 0;

        const required =
            Number(row.quantity_required) ||
            Number(row.required_quantity) ||
            0;

        // sum all assigned qty
        const assigned = (selectedVendors[material_code] || [])
            .reduce((sum, v) => sum + Number(v.selectedQty || 0), 0);

        return required - assigned;
    };




    const generatePartyWisePOs = (vendor, items) => {

        // You can also trigger your PO creation logic here using 'items'
        // , cgst_rate: 0.0, cgst_amount: 0.0, sgst_rate: 0.0, sgst_amount: 0.0, igst_rate: 0.0, igst_amount: 0.0, additional_info: '', total: 0.0
        if (items && items.length > 0) {
            const enrichedItems = items.map((item) => ({
                ...item,
                // cgst_rate: 0.0,
                // cgst_amount: 0.0,
                // sgst_rate: 0.0,
                // sgst_amount: 0.0,
                // igst_rate: 0.0,
                // igst_amount: 0.0,
                // additional_info: '',
                // total: 0.0,
            }));

            setSelectedVendorForPO(enrichedItems);  // <-- Use the enriched items here
        }

        //setSelectedVendorForPO(items);

        setVendorCompare(false);
        setPurchase_order(true);
        setOpenVendorCompareQuotation(false);
        setOpenVendorQuotation(false);
    };


    const groupedMaterialCodes = [...new Set(filteredRows.map(q => q.material_code))];



    const handleDepartmentChange = async (event, newValue) => {
        if (newValue == null) {
            setSelectedDepartment(null);
            setSelectedDepartmentID(null);
            setFilteredRows([]);
            loadVenodrIDByDepartmentID(null, 'vendor enquiry');
            loadIndentNumbersByDepartmentID(null, 'vendor enquiry', null);
            return;
        }
        setSelectedDepartment(newValue);
        setSelectedDepartmentID(newValue.id);
        loadVenodrIDByDepartmentID(newValue.id, 'vendor enquiry');
        loadIndentNumbersByDepartmentID(newValue.id, 'vendor enquiry', selectedRequestIndentNumberListID);

    };



    const generatePOs = () => {
        const vendorGrouped = {};
        const allItems = Object.values(selectedVendors).flat();

        // Only take items with status === "Pending"
        const pendingItems = Object.values(selectedVendors)
            .flat()
            .filter(item => item.status?.toLowerCase() === "pending");



        if (allItems.length === 0) {


            callMessage(
                "warning",
                "Please select at least one pending item.",
                "Warning"
            );

            return;
        }

        if (pendingItems.length === 0) {


            callMessage(
                "warning",
                "All items are already converted to a Purchase Order. Please select pending items.",
                "Warning"
            );

            return;
        }

        pendingItems.forEach(item => {
            if (!vendorGrouped[item.party_name]) {
                vendorGrouped[item.party_name] = [];
            }
            vendorGrouped[item.party_name].push(item);
        });

        setVendorGroupedPOs(vendorGrouped);
        setPoPreviewOpen(true);
    };

    const autoAllocateAllMaterials = () => {
        setSelectedVendors(() => {
            const updated = {};

            groupedMaterialCodes.forEach(material_code => {
                const materialVendors = scoredRows
                    .filter(r => r.material_code === material_code)
                    .slice()
                    .sort((a, b) => {
                        // 1️⃣ score desc
                        if (b.totalScore !== a.totalScore)
                            return b.totalScore - a.totalScore;

                        // 2️⃣ higher offer qty
                        if (b.vendor_offered_qty !== a.vendor_offered_qty)
                            return b.vendor_offered_qty - a.vendor_offered_qty;

                        // 3️⃣ lower price
                        if (a.quoted_price !== b.quoted_price)
                            return a.quoted_price - b.quoted_price;

                        // 4️⃣ earlier delivery
                        return dayjs(a.delivery_date).diff(dayjs(b.delivery_date));
                    });

                let remaining =
                    Number(materialVendors[0]?.quantity_required || 0);

                updated[material_code] = [];

                for (const vendor of materialVendors) {
                    if (remaining <= 0) break;

                    const assignQty = Math.min(
                        remaining,
                        Number(vendor.vendor_offered_qty || 0)
                    );

                    if (assignQty > 0) {
                        updated[material_code].push({
                            ...vendor,
                            selectedQty: assignQty,
                            score: vendor.totalScore
                        });

                        remaining -= assignQty;
                    }
                }

                // cleanup empty materials
                if (updated[material_code].length === 0) {
                    delete updated[material_code];
                }
            });

            return updated;
        });
    };




    return (
        <>

            {openVendorQuotation && (
                <Box padding={0}>

                    <Header title={editPurchaseIndentID === 0 ? 'New Quotation Comparison' : 'Edit Quotation Comparison'} subtitle="" callback={callback} />
                    <Divider />

                    {editPurchaseIndentID > 0 && (
                        <>
                            <EnquiryComparisionSubMenu
                                selectedButtonName={selectedButtonName}
                                setSelectedButtonName={setSelectedButtonName}
                                handlecallProcess={handlecallProcess}


                                visibleSaveBtn={visibleSaveBtn}
                                visibleApproveButton={visibleApproveButton}
                                visibleGeneratePOButton={visibleGeneratePOButton}

                                handleSave={handleSave}
                                handleApprove={handleApprove}
                                generatePOs={generatePOs}
                            />

                            <Divider />
                        </>
                    )}


                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            px: 1,
                            py: 1
                        }}
                    >
                        <Typography variant="h6"  >
                            <span style={{ color: 'red' }}>*</span> Mandatory fields
                        </Typography>
                    </Box>

                    <Grid container>
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Department <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={department}
                                        value={selectedDepartment}

                                        onChange={(event, newValue) => {
                                            handleDepartmentChange(event, newValue);


                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField color="secondary" {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Indent # <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        color="secondary"
                                        fullWidth
                                        options={requestIndentNumberList}
                                        value={selectedRequestIndentNumberList}
                                        onChange={(event, newValue) => {
                                            handlePurchaseIndentChange(event, newValue);

                                        }}
                                        getOptionLabel={(option) => option.request_indent_number || ''}
                                        renderInput={(params) => (
                                            <TextField color="secondary" {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>

                                {vendorEnquiryDet?.length > 0 && (
                                    <Grid item xs={12} sm={12} md={5} lg={5} xl={5} display="flex" justifyContent="flex-start" alignItems="center">
                                        <Typography variant="h5" fontSize={14}>
                                            ( {`Enquiry ID: ${vendorEnquiryDet[0]?.id_enquiry_hdr || '--'} | Date: ${vendorEnquiryDet[0]?.enquiry_date
                                                ? dayjs(vendorEnquiryDet[0].enquiry_date).format('DD-MMM-YYYY')
                                                : '--'
                                                }`} )
                                        </Typography>
                                    </Grid>
                                )}

                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Remarks
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={4} xl={4}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={2}
                                        label="Remarks"
                                        variant="outlined"
                                        size="small"
                                        color="secondary"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container mt={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                                <Toolbar>
                                    {(visibleSaveBtn &&
                                        <Button size="small" variant="contained" onClick={handleSave} color="secondary" startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save</Button>
                                    )}
                                </Toolbar>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>

            )}


            {/* Old comapriosn Screen */}

            {/* {(openVendorCompareQuotation) && (
                <Box>

                    <Box p={2} sx={{ mb: 0, p: 1.5 }}>
                        <Button
                            ml={2}
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<CheckCircleIcon />}
                            onClick={autoAllocateAllMaterials}
                        >
                            Auto Allocate All Materials
                        </Button></Box>

                    <Box
                        sx={{
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '40vh', // Large devices (desktops)
                                xl: '50vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        {groupedMaterialCodes.map(material_code => {
                            const materialRows = filteredRows.filter(q => q.material_code === material_code);
                            const remainingQty = getRemainingQty(material_code);

                            return (
                                <Box key={material_code} p={2} sx={{ mb: 0, p: 1.5 }}>
                                    <Box
                                        sx={{

                                            ml: 1,
                                        }}
                                    >
                                        <Typography fontWeight={'bold'} variant="h6" gutterBottom>
                                            {material_code} - {materialRows[0]?.material_description}
                                        </Typography>



                                        <Typography variant="body2" color="text.secondary">
                                            Required Delivery: {formatDate(materialRows[0]?.required_delivery_date)}
                                        </Typography>




                                    </Box>


                                    <CustomTableContainer colors={colors}>
                                        <TableContainer>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Select</TableCell>
                                                        <TableCell>Vendor</TableCell>
                                                        <TableCell>Quoted Price</TableCell>
                                                        <TableCell>Delivery Date</TableCell>
                                                        <TableCell>Delay (Days)</TableCell>

                                                        <TableCell>Payment Term</TableCell>
                                                        <TableCell>Required Qty.</TableCell>
                                                        <TableCell>Vendor Offer Qty.</TableCell>
                                                        <TableCell>Remaining Qty.</TableCell>
                                                        <TableCell>Vendor Assigned Qty.</TableCell>
                                                        <TableCell>Score</TableCell>
                                                        <TableCell>Rating</TableCell>
                                                        <TableCell>Status</TableCell>
                                                     

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {scoredRows
                                                        .filter(r => r.material_code === material_code)
                                                        .map((row, index) => {

                                                            const score = calculateScore(row.quoted_price, row.delivery_date, row.payment_terms);
                                                            const existing = selectedVendors[material_code]?.[0];
                                                            const isChecked = existing?.party_name === row.party_name;
                                                            const isConverted = row.status === "Converted";
                                                            const hasConverted = materialRows.some(r => r.status === "Converted");

                                                            const isDisabled =
                                                                globalSelectedVendor !== null && globalSelectedVendor !== row.party_name;
                                                            const requiredDate = materialRows[0]?.required_delivery_date;
                                                            const delayDays = getDelayDays(row.delivery_date, requiredDate);


                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell>
                                                                        <Tooltip title={isDisabled ? "Only one vendor can be selected globally" : "Select vendor"}>
                                                                            <span>
                                                                                <Checkbox
                                                                                    size="small"
                                                                                    color="secondary"
                                                                                   
                                                                                    disabled={
                                                                                        hasConverted ||
                                                                                        globalSelectedVendor !== null && globalSelectedVendor !== row.party_name
                                                                                    }

                                                                                    checked={selectedVendors[material_code]?.some(v => v.id_party === row.id_party)}
                                                                                    onChange={(e) => {
                                                                                        handleVendorCheck(material_code, row, e.target.checked);
                                                                                    }}
                                                                                />

                                                                            </span>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                    <TableCell>{row.party_name}</TableCell>
                                                                    <TableCell sx={{ textAlign: 'center' }}>{row.quoted_price}</TableCell>
                                                                    <TableCell>
                                                                        {dayjs(row.delivery_date).format("DD-MMM-YYYY")}
                                                                    </TableCell>
                                                                    <TableCell sx={{ textAlign: "center", fontWeight: 600 }}>
                                                                        {delayDays === null ? "-" : (
                                                                            <Typography
                                                                                component="span"
                                                                                sx={{
                                                                                    color:
                                                                                        delayDays > 3
                                                                                            ? "error.main"
                                                                                            : delayDays > 0
                                                                                                ? "warning.main"
                                                                                                : "success.main",
                                                                                }}
                                                                            >
                                                                                {delayDays > 0 ? `+${delayDays}` : delayDays}
                                                                            </Typography>
                                                                        )}
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: 'right' }}>{row.payment_terms}</TableCell>
                                                                    <TableCell sx={{ textAlign: 'right' }}>{row.quantity_required}</TableCell>
                                                                    <TableCell sx={{ textAlign: 'right' }}>{row.vendor_offered_qty}</TableCell>
                                                                    <TableCell sx={{ textAlign: 'right' }}>{getRemainingQty(material_code)}</TableCell>
                                                                    <TableCell >
                                                                        <TextField

                                                                            size="small"
                                                                            type="number"
                                                                            disabled={
                                                                                isConverted ||
                                                                                !selectedVendors[material_code]?.some(v => v.id_party === row.id_party)
                                                                            }
                                                                            value={
                                                                                selectedVendors[material_code]
                                                                                    ?.find(v => v.id_party === row.id_party)?.selectedQty || ''
                                                                            }
                                                                            onChange={(e) => {
                                                                                const qty = parseInt(e.target.value || 0);
                                                                                handleSelect(material_code, row, qty);
                                                                            }}
                                                                        />

                                                                    </TableCell>


                             

                                                                    <TableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                                                                        {row.totalScore}
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        <Tooltip title={`Rank ${row.rank} | Score ${row.totalScore}%`}>
                                                                            <Rating
                                                                                value={
                                                                                    row.rank === 1 ? 5 :
                                                                                        row.rank === 2 ? 4 :
                                                                                            row.rank === 3 ? 3 :
                                                                                                row.rank === 4 ? 2 : 1
                                                                                }
                                                                                readOnly
                                                                                size="small"
                                                                            />
                                                                        </Tooltip>
                                                                    </TableCell>



                                                                    <TableCell sx={{ textAlign: "left" }}>
                                                                        {isConverted ? (
                                                                            <Chip
                                                                                icon={<CheckCircleIcon />}
                                                                                label="PO Generated"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: "#A5D6A7",
                                                                                    color: "#1B5E20",
                                                                                    fontWeight: 600,

                                                                                  
                                                                                    "& .MuiChip-icon": {
                                                                                        color: "#1B5E20",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <Chip
                                                                                icon={<ScheduleIcon />}
                                                                                label="Pending"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: "#FFE0B2",
                                                                                    color: "#E65100",
                                                                                    fontWeight: 600,
                                                                                    "& .MuiChip-icon": {
                                                                                        color: "#E65100",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </TableCell>



               

                                                                </TableRow>
                                                            );
                                                        })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </CustomTableContainer>

                                </Box>
                            );
                        })}</Box>

                 




                </Box>
            )} */}

            {openVendorCompareQuotation && (
                <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>

                    {/* ===================== HEADER ===================== */}
                    <Box
                        sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 20,
                            backgroundColor: colors.primary[500],
                            p: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid",
                        }}
                    >
                        <Typography fontWeight={700} fontSize={17}>
                            Vendor Quotation Comparison
                        </Typography>

                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                        
                            startIcon={<AutoFixHigh />}
                            onClick={autoAllocateAllMaterials}
                        >
                            Auto Allocate Best Vendors
                        </Button>
                    </Box>

                    {/* ===================== BODY ===================== */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            p: 2,
                        }}
                    >
                        {groupedMaterialCodes.map(material_code => {
                            const materialRows = filteredRows.filter(
                                r => r.material_code === material_code
                            );

                            const requiredDate = materialRows[0]?.required_delivery_date;

                            return (
                                <Box key={material_code} mb={3}>
                                


                                    {/* ===== Material Card ===== */}
                                    <Card sx={{ mb: 1.5, backgroundColor: colors.primary[400] }}>

                              
                                        <CardContent sx={{   }}>

                                            

                                            <Typography variant="h6" fontWeight={700}>
                                            {materialRows[0]?.material_description}
                                            </Typography>

                                            <Typography variant="caption" color="text.secondary">
                                                {material_code}
                                            </Typography>

                                            <Box display="flex" gap={4} mt={1}>
                                                <Typography>
                                                    📦 Required Qty: {materialRows[0]?.quantity_required}
                                                </Typography>
                                                <Typography>
                                                    📅 Required: {formatDate(requiredDate)}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>

                                    {/* ===== Vendor Table ===== */}
                                    <TableContainer component={Paper} >
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell />
                                                    <TableCell>Vendor</TableCell>
                                                    <TableCell align="right">Price</TableCell>
                                                    <TableCell>Delivery Date</TableCell>
                                                    <TableCell align="center">Delay</TableCell>
                                                    <TableCell>Payment Term</TableCell>
                                                    <TableCell align="right">Offer Qty</TableCell>
                                                    <TableCell align="center">Assign Qty</TableCell>
                                                    <TableCell>Balance Qty</TableCell>
                                                    <TableCell align="right">Score</TableCell>
                                                    <TableCell>Status</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {scoredRows
                                                    .filter(r => r.material_code === material_code)
                                                    .map((row, index) => {
                                                        const isSelected =
                                                            selectedVendors[material_code]?.some(
                                                                v => v.id_party === row.id_party
                                                            );

                                                        const delayDays = getDelayDays(
                                                            row.delivery_date,
                                                            requiredDate
                                                        );

                                                        return (
                                                            <TableRow
                                                                key={index}
                                                                sx={{
                                                                    backgroundColor: isSelected
                                                                        ? "rgba(76,175,80,0.12)"
                                                                        : "inherit",
                                                                    borderLeft: isSelected
                                                                        ? "4px solid #4CAF50"
                                                                        : "none",
                                                                }}
                                                            >
                                                                <TableCell>
                                                                    <Checkbox
                                                                        size="small"
                                                                        color="secondary"
                                                                        checked={isSelected}
                                                                        onChange={e =>
                                                                            handleVendorCheck(
                                                                                material_code,
                                                                                row,
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                </TableCell>

                                                                <Tooltip
                                                                    title={`Payment Terms: ${row.payment_terms} days`}
                                                                >
                                                                    <TableCell>{row.party_name}</TableCell>
                                                                </Tooltip>

                                                                <TableCell align="right">
                                                                    {row.quoted_price}
                                                                </TableCell>

                                                                <TableCell>
                                                                    {dayjs(row.delivery_date).format("DD-MMM-YYYY")}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {delayDays === null ? "-" : (
                                                                        <Typography
                                                                            fontWeight={600}
                                                                            color={
                                                                                delayDays > 3
                                                                                    ? "error.main"
                                                                                    : delayDays > 0
                                                                                        ? "warning.main"
                                                                                        : "success.main"
                                                                            }
                                                                        >
                                                                            {delayDays > 0 ? `+${delayDays}` : delayDays}
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>

                                                                <TableCell align="right">{row.payment_terms}</TableCell>

                                                                <TableCell align="right">
                                                                    {row.vendor_offered_qty}
                                                                </TableCell>

                                                                <TableCell align="right">
                                                                    <TextField
                                                                        size="small"
                                                                        type="number"
                                                                        disabled={!isSelected}
                                                                        value={
                                                                            selectedVendors[material_code]
                                                                                ?.find(v => v.id_party === row.id_party)
                                                                                ?.selectedQty || ""
                                                                        }
                                                                        onChange={e =>
                                                                            handleSelect(
                                                                                material_code,
                                                                                row,
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                    />
                                                                </TableCell>

                                                                <TableCell sx={{ textAlign: 'right' }}>{getRemainingQty(material_code)}</TableCell>

                                                                <TableCell align="right" fontWeight={700}>
                                                                    {row.totalScore}
                                                                </TableCell>

                                                                <TableCell>
                                                                    {row.status === "Converted" ? (
                                                                        <Chip
                                                                            icon={<CheckCircleIcon />}
                                                                            label="PO Generated"
                                                                            size="small"
                                                                            color="success"
                                                                        />
                                                                    ) : (
                                                                        <Chip
                                                                            icon={<ScheduleIcon />}
                                                                            label="Pending"
                                                                            size="small"
                                                                            color="warning"
                                                                        />
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            );
                        })}
                    </Box>

                    {/* ===================== FOOTER ===================== */}
                    <Box
                        sx={{
                            position: "sticky",
                            bottom: 0,
                            backgroundColor: colors.primary[500],
                            p: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderTop: "1px solid",
                        }}
                    >
                        <Typography fontWeight={600}>
                            Materials Allocated: {Object.keys(selectedVendors).length}
                        </Typography>

                        {(visibleSaveBtn &&
                            <Button size="small" variant="contained" onClick={handleSave} color="secondary" startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save</Button>
                        )}



                    </Box>

                    <Dialog sx={{}} open={poPreviewOpen} onClose={() => setPoPreviewOpen(false)} maxWidth="md" fullWidth>
                        <DialogTitle
                            sx={{
                                fontWeight: '500',
                                fontSize: '18px',
                                borderBottom: '1px solid #e0e0e0',
                                pb: 1,
                                backgroundColor: colors.primary[500]
                            }}
                        >
                            Purchase Order Preview – Vendor Quotation
                        </DialogTitle>

                        <DialogContent sx={{

                            backgroundColor: colors.primary[400]
                        }}>
                            {Object.keys(vendorGroupedPOs).map(vendor => (
                                <Box key={vendor} sx={{ mb: 3 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{vendor}</Typography>



                                        <Tooltip title="Generate Purchase Order">
                                            <Button
                                                variant="contained"
                                                size="medium"
                                                style={{ fontSize: 11 }}
                                                startIcon={<CreateOutlined style={{ fontSize: 15 }} />}
                                                color="secondary"
                                                onClick={() => generatePartyWisePOs(vendor, vendorGroupedPOs[vendor])}
                                            >
                                                Generate PO
                                            </Button>
                                        </Tooltip>


                                    </Box>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Material Code</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Price</TableCell>
                                                <TableCell>Delivery Date</TableCell>
                                                <TableCell>Payment Terms</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {vendorGroupedPOs[vendor].map((item, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{item.material_code}</TableCell>
                                                    <TableCell>{item.material_description}</TableCell>
                                                    <TableCell>{item.selectedQty}</TableCell>
                                                    <TableCell>{item.quoted_price}</TableCell>
                                                    <TableCell>{item.delivery_date}</TableCell>
                                                    <TableCell>{item.payment_terms}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            ))}

                        </DialogContent>
                    </Dialog>
                </Box>
            )}


            {purchase_order && (
                <AddNewPurchaseOrder handlecallback={handlecallback} editPurchaseOrderNumber={0} vendor_details={selectedVendorForPO} purchase_indent_no={purchase_indent_no} selectedVendoIdListID={selectedVendoIdListID} />
            )}
        </>

    );
};

export default AddCompareVendorQuotations;
